import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=61c47786&scoped=true&lang=html&"
import script from "./Team.vue?vue&type=script&lang=js&"
export * from "./Team.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c47786",
  null
  
)

export default component.exports